// Actions
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';

// Action Creators
export function toggleDrawer(payload) {
  return {
    type: TOGGLE_DRAWER,
    payload,
  };
}

// Reducers
export function drawer(state = {}, action) {
  switch (action.type) {
    case TOGGLE_DRAWER: {
      const { payload } = action;
      return {
        ...state,
        isOpen: payload === undefined ? !state.isOpen : payload,
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/drawer/drawer.js